<div class="dialog-container" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div
    mat-dialog-title
    class="save-search-dialog-title"
    cdkDragHandle
  >
    <h2>Save Search Definition</h2>
    <button
      mat-icon-button
      (click)="onCancel()"
      class="save-search-close-btn"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <div class="dialog-content-no-scroll">
      <mat-form-field appearance="outline" class="save-search-name-field">
        <mat-label>Search Name</mat-label>
        <input
          matInput
          [(ngModel)]="searchName"
          placeholder="Enter search name"
          maxlength="100"
          (keyup.enter)="onSave()"
          #searchNameInput
        />
        <mat-hint>{{searchName?.length || 0}}/100</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="save-search-actions">
    <button
      mat-raised-button
      (click)="onSave()"
      [disabled]="!searchName || searchName.trim().length === 0"
      class="save-dialog-btn"
    >
      Save
    </button>
    <button mat-raised-button (click)="onCancel()" class="save-dialog-btn">
      Cancel
    </button>
  </div>
</div>
